export default "__VITE_ASSET__B67vQ0TQ__"